export default {
  SECTION_ORDER: 'tree.section-order',
  COLUMN_LAYOUT: 'tree.column-layout',
  EXPANDED_DETAILS_SECTIONS: 'tree.person-details.sections',
  CONCLUSION_DETAILED_VIEW: 'tree.person-details-expanded-state',
  PRINT_CONTACT_INFO: 'temple.printContactInfo',
  SHOW_NAMES_IN_ROMAN_SCRIPT: 'tree.showNamesInRomanScript',
  SHOW_WHATS_NEW_DIALOG: 'tree.showWhatsNewDialog',
  FAMILY_MEMBER_ALL_CHILDREN: 'tree.showAllFamilyMembers',
  MATCH_SERVICE: 'match.service',
} as const
